var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M589.3 260.9v30H371.4v-30H268.9v513h117.2v-304l109.7-99.1h202.1V260.9z",
    fill: "#E1F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M516.1 371.1l-122.9 99.8v346.8h370.4V371.1z",
    fill: "#E1F0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M752.7 370.8h21.8v435.8h-21.8z",
    fill: "#446EB1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M495.8 370.8h277.3v21.8H495.8z",
    fill: "#446EB1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M495.8 370.8h21.8v124.3h-21.8z",
    fill: "#446EB1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M397.7 488.7l-15.4-15.4 113.5-102.5 15.4 15.4z",
    fill: "#446EB1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M382.3 473.3h135.3v21.8H382.3z",
    fill: "#446EB1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M382.3 479.7h21.8v348.6h-21.8zM404.1 806.6h370.4v21.8H404.1z",
    fill: "#446EB1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M447.7 545.1h261.5v21.8H447.7zM447.7 610.5h261.5v21.8H447.7zM447.7 675.8h261.5v21.8H447.7z",
    fill: "#6D9EE8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M251.6 763h130.7v21.8H251.6z",
    fill: "#446EB1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M251.6 240.1h21.8v544.7h-21.8zM687.3 240.1h21.8v130.7h-21.8zM273.4 240.1h108.9v21.8H273.4z",
    fill: "#446EB1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M578.4 240.1h130.7v21.8H578.4zM360.5 196.5h21.8v108.9h-21.8zM382.3 283.7h196.1v21.8H382.3zM534.8 196.5h65.4v21.8h-65.4z",
    fill: "#446EB1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 196.5h65.4v21.8h-65.4zM404.1 174.7h152.5v21.8H404.1zM578.4 196.5h21.8v108.9h-21.8z",
    fill: "#446EB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.86f269ae2563211686cbb30bacd80734.svg";
export { ForwardRef as ReactComponent };